export enum AUTO_CAPITALIZE {
    NONE = 'none',
    OFF = 'off',
    ON = 'on',
    SENTENCES = 'sentences',
    WORDS = 'words',
    CHAR = 'characters'
}

export enum INPUT_TYPE {
    DECIMAL = 'decimal',
    EMAIL = 'email',
    NONE = 'none',
    NUMERIC = 'numeric',
    SEARCH = 'search',
    TEL = 'tel',
    URL = 'url',
    TEXT = 'text',
    PASS = 'password'
}

export enum AUTO_CORRENT {
    OFF = 'off',
    ON = 'on'
}
